import React from "react";
import { Alert, Button, Col, DropdownMenu, Row, BodyText, TextInput, TextDisplay, HeadingText, CaptionText } from '@paypalcorp/pp-react';
import LogoImage from './LogoImage';
import ReactHtmlParser from 'react-html-parser';
import { filter, remove, get } from 'lodash';
import { ENROLL_CHAR_COUNT } from '../../../../constants/constants';
import { parseMessages } from '../../utilityHelper';
import { links } from '../../../../constants/links.json';
import withTheme from "../../common/withTheme";

const propertyInfo = parseMessages('directmodel/home');
const missionAreaContent = parseMessages('enrollment');

class EnrollmentForm extends React.Component {
    static getDerivedStateFromProps(props, state) {
        return { errors: props.enrollmentFormFields.errors };
    }

    constructor(props) {
        super(props);
        const primaryMission = filter(get(this.props.enrollmentFormFields.charityInfo, 'missionAreaList', []), (obj) => { return obj.is_primary; });
        const nonPrimaryMission = filter(get(this.props.enrollmentFormFields.charityInfo, 'missionAreaList', []), (obj) => { return !obj.is_primary; });
        this.state = {
            update: document.getElementById('data-intent') && document.getElementById('data-intent').innerHTML,
            serviceError: false,
            inputMissionAreaSelect: primaryMission[0] ? primaryMission[0].id.toString() : '',
            inputMissionAreaSecondSelect: nonPrimaryMission[0] ? nonPrimaryMission[0].id.toString() : '',
            inputMissionAreaThirdSelect: nonPrimaryMission[1] ? nonPrimaryMission[1].id.toString() : '',
            errors: []
        }
    }

    updateMissionAreaSelect = (event) => {
        this.setState({
            inputMissionAreaSelect: event.target.value
        });
        this.props.missionAreaSelectHandler(event.target.value);
    }
    updateMissionAreaSecondSelect = (event) => {
        this.setState({
            inputMissionAreaSecondSelect: event.target.value
        });
        this.props.missionAreaSecondSelectHandler(event.target.value);
    }
    updateMissionAreaThirdSelect = (event) => {
        this.setState({
            inputMissionAreaThirdSelect: event.target.value
        });
        this.props.missionAreaThirdSelectHandler(event.target.value);
    }

    onFocus = (event) => {
        let fieldId;
        let errors = this.state.errors;
        remove(errors, (field) => {
            if (field == 'missionArea') fieldId = 'missionArea';
            else fieldId = event.target.id;
            return field === fieldId
        });
        this.setState({ errors: errors });
    }

    onKeyUp = (event) => {
        const maxLength = event.target.getAttribute('maxLength');
        let remainingChars = maxLength - event.target.value.length;
        this.onFocus(event);
        document.getElementsByClassName(event.target.id + 'Counter')[0].innerHTML = remainingChars;
    }

    render() {
        let missionAreasOptions = JSON.parse(document.getElementById('data-mission-areas') && document.getElementById('data-mission-areas').innerHTML).map(function (missionarea) {
            let missionAreaLabel = missionAreaContent[missionarea.id] ? missionAreaContent[missionarea.id] : missionarea.name;
            return {
                value: missionarea.id.toString(),
                primaryText: missionAreaLabel
            };
        });
        const descriptionBottomnote = get(propertyInfo, 'directmodel.enroll.description.bottomnote').replace(/511/g, ENROLL_CHAR_COUNT.DESCRIPTION),
            ctaBottomnote = get(propertyInfo, 'directmodel.enroll.cta.bottomnote').replace(/90/g, ENROLL_CHAR_COUNT.SLOGAN),
            keywordsBottomnote = get(propertyInfo, 'directmodel.enroll.keywords.bottomnote').replace(/255/g, ENROLL_CHAR_COUNT.KEYWORDS),
            ppfpAgreementURL = get(links, 'default.ppfpAgreement', ''),
            agreementText = (propertyInfo && propertyInfo.directmodel.enroll.agreement) ? propertyInfo.directmodel.enroll.agreement.replace('{ppfpAgreementURL}', ppfpAgreementURL) : '';

        return (
            <>
                {this.state.serviceError && <Alert type="error">{ReactHtmlParser(get(propertyInfo, 'directmodel.enroll.errorMsg'))}</Alert>}
                <Row style={{ margin: '2rem 0' }}>
                    <HeadingText>{this.state.update ? get(propertyInfo, 'directmodel.enroll.update.header') : get(propertyInfo, 'directmodel.enroll.header')}</HeadingText>
                </Row>
                <Row>
                    <Col>
                        <HeadingText size='sm'>
                            {get(propertyInfo, 'directmodel.enroll.label.charitydesc')}
                        </HeadingText>
                        <TextDisplay value={get(propertyInfo, 'directmodel.enroll.description.note')} />
                        <TextInput label={get(propertyInfo, 'directmodel.enroll.description.placeholder')} onFocus={this.onFocus} errorText={this.state.errors.includes('desc') && get(propertyInfo, 'directmodel.enroll.description.error')} onKeyUp={this.onKeyUp} value={this.props.enrollmentFormFields.charityInfo.description} id="desc" name="desc" maxLength={ENROLL_CHAR_COUNT.DESCRIPTION} />
                        <div style={{ marginTop: '15px' }}>
                            <TextDisplay style={{ marginTop: '15px' }} label={ReactHtmlParser(descriptionBottomnote)} />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <HeadingText size='sm'>
                            {get(propertyInfo, 'directmodel.enroll.label.cta')}
                        </HeadingText>
                        <TextDisplay value={get(propertyInfo, 'directmodel.enroll.cta.note')} />
                        <TextInput label={get(propertyInfo, 'directmodel.enroll.cta.placeholder')} onFocus={this.onFocus} errorText={this.state.errors.includes('cta') && get(propertyInfo, 'directmodel.enroll.cta.error')} value={this.props.enrollmentFormFields.charityInfo.slogan} onKeyUp={this.onKeyUp} id="cta" name="cta" maxLength={ENROLL_CHAR_COUNT.SLOGAN} />
                        <div style={{ marginTop: '15px' }}><TextDisplay label={ReactHtmlParser(ctaBottomnote)} /></div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <LogoImage
                            propertyInfo={propertyInfo}
                            fileUrl={this.props.enrollmentFormFields.fileUrl}
                            fileError={this.props.enrollmentFormFields.fileError}
                            updateFileError={this.props.enrollmentFormFields.updateFileError}
                            updateFileInfo={this.props.enrollmentFormFields.updateFileInfo} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <HeadingText size='sm'>
                            {get(propertyInfo, 'directmodel.enroll.missionarea.title')}
                        </HeadingText>
                        <TextDisplay value={get(propertyInfo, 'directmodel.enroll.missionarea.note')}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <BodyText style={{ margin: '20px 0px' }}>{get(propertyInfo, 'directmodel.enroll.primarymissionarea.title')}</BodyText>
                        <DropdownMenu
                            name="missionArea"
                            id="missionArea"
                            errorText={this.state.errors.includes('missionArea') && get(propertyInfo, 'directmodel.enroll.primarymissionarea.error')}
                            options={missionAreasOptions}
                            onChange={(e) => { this.updateMissionAreaSelect(e) }}
                            label={missionAreaContent.enrollment.selectCauseArea}
                            value={this.props.inputMissionAreaSelect}
                            onFocus={this.onFocus}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <BodyText style={{ margin: '20px 0px' }} >{get(propertyInfo, 'directmodel.enroll.secondarymissionarea.title')}</BodyText>
                        <DropdownMenu
                            name="missionAreaSecond"
                            id="missionAreaSecond"
                            options={missionAreasOptions}
                            onChange={(e) => { this.updateMissionAreaSecondSelect(e) }}
                            label={missionAreaContent.enrollment.selectCauseArea}
                            value={this.props.inputMissionAreaSecondSelect}
                        />
                        <BodyText style={{ margin: '20px 0px' }} ></BodyText>
                        <DropdownMenu
                            name="missionAreaThird"
                            id="missionAreaThird"
                            options={missionAreasOptions}
                            onChange={(e) => { this.updateMissionAreaThirdSelect(e) }}
                            label={missionAreaContent.enrollment.selectCauseArea}
                            value={this.props.inputMissionAreaThirdSelect}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: '2rem'}}>
                    <Col>
                        <HeadingText size='sm'>{get(propertyInfo, 'directmodel.enroll.keywords.title')}</HeadingText>
                        <TextDisplay value={get(propertyInfo, 'directmodel.enroll.keywords.note')} />
                        <TextInput onFocus={this.onFocus} errorText={this.state.errors.includes('keywords') && get(propertyInfo, 'directmodel.enroll.keywords.error')} value={this.props.enrollmentFormFields.charityInfo.keywords} onKeyUp={this.onKeyUp} label={get(propertyInfo, 'directmodel.enroll.keywords.placeholder')} id="keywords" name="keywords" maxLength={ENROLL_CHAR_COUNT.KEYWORDS} />
                        <div style={{ marginTop: '15px' }}><TextDisplay label={ReactHtmlParser(keywordsBottomnote)} /></div>
                    </Col>
                </Row>
                {(!(this.state.update) && (this.props.enrollmentFormFields.charityInfo.retireConsentPage)) && <p>{ReactHtmlParser(agreementText)}</p>}
                {!(this.state.update) &&
                    <Row>
                        <Col style={{ textAlign: 'center' }}>
                            <Button onClick={this.props.enrollSubmit} id="enrollSubmit">
                                {this.props.enrollmentFormFields.charityInfo.retireConsentPage ?
                                    get(propertyInfo, 'directmodel.enroll.agreeContinue') : get(propertyInfo, 'directmodel.enroll.continue')
                                }
                            </Button>
                        </Col>
                    </Row>
                }
            </>
        )
    }
}
export default withTheme(EnrollmentForm);